<template>
   <div class="contract-and-performance-data-general">
      <div :class="`contract-and-performance-data-general__fulltimes`">
         <SuspenseSection :with-table="true" :loading-col-count="7">
            <Fulltimes />
         </SuspenseSection>
      </div>
      <div :class="`contract-and-performance-data-general__shifts`">
         <SuspenseSection :with-table="true" :loading-col-count="7">
            <Shifts />
         </SuspenseSection>
      </div>
      <div :class="`contract-and-performance-data-general__contract-info`">
         <SuspenseSection>
            <ContractInfo />
         </SuspenseSection>
      </div>
   </div>
</template>

<script setup lang="ts">
import SuspenseSection from '@/core/components/loading-elements/SuspenseSection.vue';
import { defineAsyncComponent } from 'vue';

const ContractInfo = defineAsyncComponent(() => import('./ContractInfo.vue'));
const Fulltimes = defineAsyncComponent(() => import('./fulltimes/Fulltimes.vue'));
const Shifts = defineAsyncComponent(() => import('./shifts/Shifts.vue'));
</script>

<style lang="scss">
.contract-and-performance-data-general {
   display: grid;
   gap: var(--nxt-gutter);
   grid-template-columns: 1fr toRem(350);
   grid-template-rows: auto auto;
   grid-template-areas:
      'fulltimes contract-info'
      'shifts contract-info';

   &__fulltimes {
      grid-area: fulltimes;
   }

   &__shifts {
      grid-area: shifts;
   }

   &__contract-info {
      grid-area: contract-info;
   }

   @include sm {
      grid-template-columns: 1fr;
      grid-template-areas:
         'contract-info'
         'fulltimes'
         'shifts';
   }
}
</style>
